/*
 * @Author: lc
 * @Date: 2023-10-07 12:04:00
 * @LastEditors: lc
 * @LastEditTime: 2024-08-19 15:18:51
 * @FilePath: \vue3androuter\src\main.ts
 * @Description: 
 */
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import "amfe-flexible"
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
// import wx from "weixin-js-sdk";
const app = createApp(App)
// app.config.globalProperties.$wxsdk = wx
app.use(ElementPlus).use(store).use(router).mount('#app')
